export const microservices = {
    keycloak: {
        GBR: {
            local: 'https://auth-gbr-development.raisin-dev.network/auth/realms/global',
            development: 'https://auth-gbr-development.raisin-dev.network/auth/realms/global',
            staging: 'https://auth.staging-raisin.co.uk/auth/realms/global',
            onboarding: 'https://auth.onboarding-raisin.co.uk/auth/realms/global',
            production: 'https://auth.raisin.co.uk/auth/realms/global',
        },
        DEU: {
            local: 'https://auth-deu-development.raisin-dev.network/auth/realms/global',
            development: 'https://auth-deu-development.raisin-dev.network/auth/realms/global',
            staging: 'https://auth.staging-weltsparen.de/auth/realms/global',
            onboarding: 'https://auth.onboarding-weltsparen.de/auth/realms/global',
            production: 'https://auth.weltsparen.de/auth/realms/global',
        },
    },
};
//# sourceMappingURL=microservices.js.map